// extracted by mini-css-extract-plugin
module.exports = {"footerList":"Footer_footerList__lKm7J","item":"Footer_item__3zz3a"};